import { ShoppingCartIcon } from '@grupoboticario/flora-react-icons';
import { Cart } from './Header.components.styles';
import { counterMaxValue } from './Header.components.helpers';
import type { CartProps } from './Header.components';

const HeaderCart = ({ cartItemCount, onClickCart, disabled }: CartProps) => (
  <Cart.Component
    disabled={disabled}
    onClick={onClickCart}
    stretch={false}
    variant="conversion"
    data-label={`Pedido atual com ${cartItemCount} ${cartItemCount > 1 ? 'itens' : 'item'}`}
  >
    <span>Pedido</span>
    <ShoppingCartIcon />
    {cartItemCount > 0 && <Cart.Counter>{counterMaxValue(cartItemCount)}</Cart.Counter>}
  </Cart.Component>
);

export default HeaderCart;
